import React, {useState, useEffect, useContext, Fragment} from 'react'

import {ApiServiceContext, BasketContext} from '../../context'

import OrderListCard from '../../order-list-card'
import OrderForm from '../../order-form'
import BreadCrumbs from "../../bread-crumbs";

const Order = ({history}) => {
  const apiService = useContext(ApiServiceContext);
  const {basket, setBasket, cartId} = useContext(BasketContext);
  const [prices, setPrices] = useState([]);
  const [basketSum, setBasketSum] = useState();

  const orderList = basket.map(({id, size, amount}) => (
    <OrderListCard params={id}
                   id={id}
                   size={size}
                   amount={amount}
                   cartId={cartId}
                   basket={basket}
                   setBasket={setBasket}
                   prices={prices}
                   setPrices={setPrices}
                   key={`${id}${size}`}/>
  ));

  useEffect(() => {
    if (basket.length === 0) {
      history.push('/')
    }
  }, [basket]);

  useEffect(() => {
    if (prices.length) {
      const newBasketSum = basket.reduce((sum, item) => {
        const currentItem = prices.filter(({id}) => id === item.id)[0];
        const price = currentItem && currentItem.price;
        if (price) {
          return sum += price
        }
        return sum
      }, 0);
      newBasketSum && setBasketSum(newBasketSum)
    }
  }, [basket, prices]);

  const orderSubmit = (name, tel, email, address, paid) => {
    const data = {
      "name": name,
      "phone": tel,
      "email": email,
      "address": address,
      "paymentType": paid.type,
      "paymentTitle": paid.title,
      "orderTotal": basketSum,
      "cart": cartId
    };

    apiService.setOrder(data)
      .then(({data}) => {
        const {info} = data;
        if (info) {
          const {name, phone, email, address, paymentTitle, orderTotal, cart} = info;

          if (cart === cartId) {
            history.push({
              pathname: '/order-done',
              state: {
                order: {
                  cart,
                  name,
                  phone,
                  email,
                  address,
                  paymentTitle,
                  orderTotal
                }
              }
            })
          } else {
            history.push('/') //на страницу ошибки
          }
        }
      })
      .catch(console.error)
  };

  return (
    <Fragment>
        <div className="wrapper order-wrapper">
          <BreadCrumbs path={[
            {title: 'Корзина', link: '/order'},
            {title: 'Оформление заказа'}
            ]}/>
          <section className="order-process">
            <h2 className="order-process__title">Оформление заказа</h2>
            <div className="order-process__basket order-basket">
              <div className="order-basket__title">в вашей корзине:</div>
              <div className="order-basket__item-list">
                {orderList}
              </div>
              {basketSum &&
                (<div className="order-basket__summ">
                  Итого:&nbsp;
                  <span>{basketSum.toLocaleString('ru-RU')}<i className="fa fa-rub" aria-hidden="true"/></span>
                </div>)
              }
            </div>
            <div className="order-process__confirmed">
              <OrderForm orderSubmit={orderSubmit}/>
            </div>
          </section>
        </div>
    </Fragment>
  )
};

export default Order